export default "__VITE_ASSET__22e96041__"